import { render, staticRenderFns } from "./AccessorialChargesModal.vue?vue&type=template&id=01058d55"
import script from "./AccessorialChargesModal.vue?vue&type=script&lang=ts"
export * from "./AccessorialChargesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports